import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Box, CircularProgress } from '@mui/material';
import { AppColors } from '../theme/colors';

export const InitialRoute: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          bgcolor: AppColors.surface,
        }}
      >
        <CircularProgress
          size={60}
          thickness={4}
          sx={{ color: AppColors.primary }}
        />
      </Box>
    );
  }

  // 未ログインの場合は管理者ログイン画面へ。
  //
  // ここを開くのはほぼ管理者。投稿する方はQR・専用URL（/q/:token）や
  // ホーム画面から入るため、そちらでQRの案内画面へ送っている。
  // 入り方で振り分けるとブラウザごとの記録に依存し、記録が消えるまで
  // 管理者ログイン画面に行けなくなるため、ここでは分けない。
  return <Navigate to={user ? '/home' : '/admin-login'} replace />;
};

